module.exports = window.wp.theme;